import { useContext, useMemo } from 'react';

import { CartContext } from '@/app/(ordering)/shop/CartProvider/CartProvider';
import Link from 'next/link';
import { OrderIcon } from '@/components/common/Icons/OrderIcon';
import styles from './ViewMyOrderButton.module.css';

export function ViewMyOrderButton() {
	const { apiCart } = useContext(CartContext);

	const total = useMemo(() => {
		return apiCart?.products?.reduce((sum, product) => sum + (product.quantity || 0), 0) ?? 0;
	}, [apiCart?.products]);

	return (
		total > 0 && (
			<Link
				id="view-order-button"
				href="/checkout"
				className={`flex sm:hidden ${styles.orderButton}`}
				onClick={() => {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'view_order',
						eventModel: {
							value: apiCart?.subtotal,
							tax: apiCart?.taxes?.reduce((previousVal, taxItem) => taxItem.tax + previousVal, 0),
							shipping: apiCart?.deliveryFee,
							currency: 'USD',
							orderTotal: apiCart?.total,
							itemsPurchased: JSON.stringify(apiCart?.products),
							storeNumber: apiCart?.storeNumber,
							zipcode: apiCart?.restaurant?.zip,
							coupon: apiCart?.couponCode,
							items: apiCart?.products?.map((product) => ({
								item_id: product.sku,
								item_name: product.name,
								item_category: product.category,
								location_id: apiCart.storeNumber,
								price: product.totalCost / product.quantity,
								quantity: product.quantity,
							})),
						},
					});
				}}
			>
				<OrderIcon height={'20px'} />
				<div data-type-style="body-3" className={`${styles.textWhite}`}>
					view order
				</div>
				<div
					data-type-style="body-3"
					className={`absolute right-[-2px] top-[-9px] ${styles.textWhite} ${styles.quantity}`}
				>
					{total}
				</div>
			</Link>
		)
	);
}
